<template>
    <div class="card mb-3" :class="{
        'bg-light': bg,
        'bg-ghost': !bg,
        'h-100': h100,
    }">
        <img :src="article.eyecatch" v-if="article.eyecatch" class="bg-placeholder-img card-img-top cover">
        <img v-lazy="cover()" v-else class="bg-placeholder-img card-img-top cover" />
        <div class="card-body">
            <h5 class="card-title font-weight-bold">
                <div v-if="noLink">
                    <i class="far fa-eye text-primary" v-if="article.publish_at"></i>
                    <i class="far fa-eye-slash text-danger" v-else></i>
                    {{article.title}}
                    <i class="fas fa-edit" v-if="isModified"></i>
                    <i class="fas fa-external-link-alt" v-if="article.url"></i>
                </div>
                <router-link :to="url" class="black stretched-link" v-else>
                    <i class="far fa-eye text-primary" v-if="article.publish_at"></i>
                    <i class="far fa-eye-slash text-danger" v-else></i>
                    {{article.title}}
                    <i class="fas fa-edit" v-if="isModified"></i>
                    <i class="fas fa-external-link-alt" v-if="article.url"></i>
                </router-link>
                <span class="badge" :class="['badge-' + article.rating.color]" v-if="article.rating">{{article.rating.rating_name}}</span>
            </h5>
            <div class="text-muted preface" v-if="showPreface">
                {{$filters.truncate(article.preface, 200)}}
            </div>
            <div class="text-right small" v-if="showPreface">
                <span v-if="article.publish_at">
                    {{$filters.dateFormat(article.publish_at)}}
                </span>
                <span v-else class="text-danger">未公開</span>
            </div>
            <div v-if="showPreface && article.tags">
                <ul class="tag-list mt-2">
                    <li v-for="t in article.tags" :key="'tag-' + t.id">
                        {{t.tag_name}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.cover {
    object-fit: cover;
    max-height: 190px;
    min-height: 190px;
    width: 100%;
}
.article {
    max-height: 250px;
    overflow: hidden;
}
.badge-light {
    padding: .3rem .7rem;
}
.badge {
    font-size: .7rem;
}
.preface {
    display: -webkit-box;
    font-size: .7rem;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: .7rem
}
.tag-list {
    li {
        font-size: .7rem;
    }
}
.bg-ghost {
    background-color: rgba(255, 255, 255, .4);
}
</style>

<script>
export default {
    props: {
        article: {
            required: true,
        },
        showPreface: {
            default: true,
        },
        bg: {
            default: true,
        },
        h100: {
            default: true,
        },
        noLink: {
            default: false
        }
    },
    methods: {
        cover() {
            const index = Math.floor(Math.random() * this.$store.getters.novelCovers.length);
            return this.$store.getters.novelCovers[index];
        },
    },
    computed: {
        isModified() {
            if (!this.article.publish_at) {
                return false;
            }
            const diff = Math.abs(moment(this.article.publish_at).unix() - moment(this.article.updated_at).unix());
            return diff > 2;
        },
        page() {
            if (this.$route.query.page) {
                return "?page=" + this.$route.query.page;
            }
            return "";
        },
        url() {
            if (!this.article.id) {
                return '#';
            }
            if (this.article.url) {
                let page = this.page;
                if (page.length) {
                    page += "&ogp=1";
                } else {
                    page += "?ogp=1";
                }
                return '/mypage/article/' + this.article.id + page;
            }
            return '/mypage/article/' + this.article.id + this.page;
        },
    }
}
</script>